import React from "react";
import { useTranslation } from "react-i18next";
import "./erp.css";
import Header from "../../../components/header/header";
import Footer from "../../../components/footer/footer";
import BannerComponent from "../../../components/bannerComponent/bannerComponent";
import BenefitsCardsComponent from "../../../components/benefitsCardsComponent/benefitsCardsComponent";
import ButtonLinkComponent from "../../../components/buttonLink/buttonLink.jsx";

const ERP_MoreServices = () => {
  const { t } = useTranslation();

  function openBooking() {
    const BOOKING_URL =
      "https://outlook.office365.com/book/G07e86683359a41f58322cab8b2047723@5igsolutions.com/?ismsaljsauthenabled=true&RefID=ERP";

    window.open(BOOKING_URL, "_blank", "noopener,noreferrer");
  }

  const heroData = {
    title: t("MORE_SERVICE_ERP_SUBTITLE1"),
    title2: t("MORE_SERVICE_ERP_SUBTITLE2"),
    text: t("MORE_SERVICE_ERP_DESCRIPTION"),
    className: "erpHeroBanner",
    chipText: "ERP",
  };

  const cardBenefitsData = [
    {
      title: t("MORE_SERVICE_ERP_FINANCE_MANAGEMENT"),
      text: t("MORE_SERVICE_ERP_FINANCE_MANAGEMENT_DESC"),
      icon: "money_Icon.svg",
    },
    {
      title: t("MORE_SERVICE_ERP_SUPPLY_CHAIN_OPTIMIZATION"),
      text: t("MORE_SERVICE_ERP_SUPPLY_CHAIN_OPTIMIZATION_DESC"),
      icon: "transport_Icon.svg",
    },
    {
      title: t("MORE_SERVICE_ERP_HUMAN_RESOURCES"),
      text: t("MORE_SERVICE_ERP_HUMAN_RESOURCES_DESC"),
      icon: "HR_Icon.svg",
    },
  ];

  const processData = [
    {
      title: t("MORE_SERVICE_ERP_ASSESS_NEEDS"),
      text: t("MORE_SERVICE_ERP_ASSESS_NEEDS_DESC"),
      img: "/img/Default_Generate_a_realistic_image_of_a_corporate_setting_with_1 2.jpg",
    },
    {
      title: t("MORE_SERVICE_ERP_TAILOR_SOLUTION"),
      text: t("MORE_SERVICE_ERP_TAILOR_SOLUTION_DESC"),
      img: "/img/busy-businessman-typing-computer-keyboard-indoors-night-generated-by-artificial-intelligence 1.jpg",
    },
    {
      title: t("MORE_SERVICE_ERP_IMPLEMENT_TRAIN"),
      text: t("MORE_SERVICE_ERP_IMPLEMENT_TRAIN_DESC"),
      img: "/img/hombre-pasando-rato-robot 1.jpg",
    },
    {
      title: t("MORE_SERVICE_ERP_ONGOING_SUPPORT"),
      text: t("MORE_SERVICE_ERP_ONGOING_SUPPORT_DESC"),
      img: "/img/portrait-man-working-as-telemarketer 1.jpg",
    },
  ];

  const keyData = [
    {
      title: t("MORE_SERVICE_ERP_CENTRALIZED_DATA_MANAGEMENT"),
    },
    {
      title: t("MORE_SERVICE_ERP_IMPROVED_EFFICIENCY_PRODUCTIVITY"),
    },
    {
      title: t("MORE_SERVICE_ERP_REAL_TIME_REPORTING_ANALYTICS"),
    },
    {
      title: t("MORE_SERVICE_ERP_SCALABLE_SOLUTIONS_GROWING_BUSINESSES"),
    },
  ];

  function ProcessCard({ img, title, text, step }) {
  return (
    <article className="erpProcessCard">

      <div className="erpProcessMedia">
        <img src={img} alt={title} />
      </div>

      <div className="erpProcessContent">

        <div className="erpStepNumber">
          {step}
        </div>

        <h3>{title}</h3>
        <p>{text}</p>

      </div>

    </article>
  );
}

  function BenefitCard({ text }) {
    return (
      <article className="erpBenefitCard">
        <p>{text}</p>
      </article>
    );
  }

  return (
    <>
      <Header />

      <main className="erpPage">
        <section className="erpHero erpHeroFull">
          <div className="erpHeroBannerFull">
            <BannerComponent
              translateTitle={`${heroData.title} ${heroData.title2}`}
              translateText={heroData.text}
              className={heroData.className}
              classNameSide="l"
              translateButton={t("MORE_SERVICE_ERP_CTA")}
              chipText={heroData.chipText}
              onClick={openBooking}
              headingTag="h1"
            />
          </div>
        </section>

        <section className="erpFeatures">
          <div className="erpFeaturesWrap">
            <div className="erpSectionIntro">
              <h2>{t("MORE_SERVICE_ERP_KEY_FEATURES_TITLE")}</h2>
              <p>
                {t("MORE_SERVICE_ERP_KEY_FEATURES_DESC")}
              </p>
            </div>

            <BenefitsCardsComponent title="" cardsData={cardBenefitsData} />
          </div>
        </section>

        <section className="erpProcess">
            <div className="erpSectionIntro">
                <h2>{t("MORE_SERVICE_ERP_PROCESS_TITLE")}</h2>
                <p>
                {t("MORE_SERVICE_ERP_PROCESS_DESC")}
                </p>
            </div>

            <div className="erpProcessTimeline">
                <div className="erpProcessGrid">
                {processData.map((process, index) => (
                    <ProcessCard
                    key={index}
                    step={index + 1}
                    title={process.title}
                    text={process.text}
                    img={process.img}
                    />
                ))}
                </div>
            </div>
        </section>

        <section className="erpBenefits">
          <div className="erpBenefitsWrap">
            <div className="erpSectionIntro">
              <h2>{t("MORE_SERVICE_ERP_BUSINESS_BENEFITS_TITLE")}</h2>
              <p>
                {t("MORE_SERVICE_ERP_BUSINESS_BENEFITS_DESC")}
              </p>
            </div>

            <div className="erpBenefitsGrid">
              {keyData.map((benefit, index) => (
                <BenefitCard key={index} text={benefit.title} />
              ))}
            </div>
          </div>
        </section>

        <section className="erpCta">
          <div className="erpCtaInner">
            <div className="erpCtaContent">
              <h2>
                {t("MORE_SERVICE_ERP_FINAL_TITLE")}
              </h2>
              <div className="erpCtaText">
                <p>
                  {t("MORE_SERVICE_ERP_FINAL_DESC")}
                </p>
              </div>
            </div>

            <ButtonLinkComponent
              translateButton={t("MORE_SERVICE_ERP_CTA")}
              url={
                "https://outlook.office365.com/book/G07e86683359a41f58322cab8b2047723@5igsolutions.com/?RefID=ERP"
              }
              blank={true}
            />
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
};

export default ERP_MoreServices;